var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.6 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5,36.1h-11c-0.9,0-1.6-0.7-1.5-1.6l1.7-28c0.4-6.4-8-9-11.3-3.5L0.9,49.6c-2.5,4.1,0.4,9.3,5.2,9.3h11 c0.9,0,1.6,0.7,1.5,1.6l-1.7,28c-0.4,6.4,8,9,11.3,3.5l28.5-46.7C59.2,41.3,56.3,36.1,51.5,36.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningIcon);
export default __webpack_public_path__ + "static/media/lightning-icon.9f6cf35020734284bdaa697278d56cd3.svg";
export { ForwardRef as ReactComponent };